<a
    class="relative w-10 h-10 rounded-lg p-2.5 overflow-hidden bg-blurple-dark"
    routerLink="/dashboard">
    <img [src]="'../../../../assets/images/logo.svg'" alt="Focusmate Logo" class="w-full h-full" />
</a>
